import { useEffect, useState } from 'react';
import { getCurrentAgency } from '../services/admin/agency.service';
import { disciplineCodes } from '../constants/disciplines';

/**
 * Phase 20A: the disciplines the agency offers (Agency Setup > Services offered), in registry order.
 * Starts with every active discipline and narrows once the agency profile loads. Users who cannot
 * read the agency profile keep the full list; the backend still refuses a discipline that is off
 * (422 SERVICE_NOT_OFFERED).
 */
let cache: Promise<string[]> | null = null;

function loadOffered(): Promise<string[]> {
  if (!cache) {
    cache = getCurrentAgency()
      .then(agency => {
        const all = disciplineCodes();
        const offered = Array.isArray(agency?.servicesOffered) ? all.filter(d => agency!.servicesOffered!.includes(d)) : all;
        return offered.length ? offered : all;
      })
      .catch(() => disciplineCodes());
  }
  return cache;
}

/** Forget the cached list (after Agency Setup saves). */
export function clearServicesOfferedCache(): void {
  cache = null;
}

export function useServicesOffered(): string[] {
  const [offered, setOffered] = useState<string[]>(() => disciplineCodes());
  useEffect(() => {
    let alive = true;
    loadOffered().then(list => { if (alive) setOffered(list); });
    return () => { alive = false; };
  }, []);
  return offered;
}
